<template>
  <div class="container">
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>报表设置</el-breadcrumb-item>
    </el-breadcrumb>

    <div style="display: flex;justify-content: space-between">
      <div style="width: 30%">
        <div class="left_inner_con">
          <el-input size="mini"
                    style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                    placeholder="输入关键字进行过滤"
                    v-model="filterText">
          </el-input>
          <el-tree
            :data="orgList"
            :props="treeProps"
            :highlight-current="true"
            node-key="id"
            :filter-node-method="filterNode"
            show-checkbox
            @check="handleCheckChange"
            ref="tree">
          </el-tree>
        </div>
      </div>
      <div style="rgb(222,222,222);width: 100%;height: 600px;">
        <el-button size="mini" @click="showAddReportKpiDialog">新建报表统计项目</el-button>
        <el-button size="mini" @click="orgReportSet">机构配置报表统计项目</el-button>
        <el-card style="height: 550px;">
          <el-checkbox-group v-model="orgReportKpi.reportKpiIds" size="small">
            <el-checkbox v-for="(kpi,index) in reportKpis"
                         :label="kpi.id"
                         :key="index">
              {{kpi.cnName}}
            </el-checkbox>
          </el-checkbox-group>
        </el-card>
        <br>
      </div>
    </div>

    <el-dialog
      title="报表统计项目"
      :visible.sync="reportKpiDialogVisible"
      width="40%"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div style="display: flex;justify-content:flex-start;flex-wrap:wrap;align-items: center;margin-top: 20px">
        <div style="width: 100%">
          <span style="width: 40%">报表统计项目名称：</span>
          <el-input size="mini" v-model="reportKpi.cnName" style="width: 60%"/>
        </div>

        <div style="width: 100%;margin-top: 20px">
          <span style="width: 30%">显示顺序：</span>
          <el-input size="mini" v-model="reportKpi.orderNo" style="width: 70%"/>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="closeAddReportKpiDialog">取 消</el-button>
          <el-button size="mini" @click="createReportKpi">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      orgList: [],
      currentOrgId:'',
      authorities:'',
      userId:'',
      reportKpis:[],
      reportKpiDialogVisible:false,
      reportKpi:{
        cnName:'',
        orderNo:'',
        creator:''
      },
      orgReportKpi:{
        orgIds:[],
        reportKpiIds:[]
      },
      treeProps: {
        label: 'orgName',
        children: 'children'
      },
      filterText: '',
      selectOrgId:'',
    }
  },
  methods:{
    filterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    handleCheckChange(data) {
      this.selectOrgId = data.id;
      this.loadOrgReportKpis();
    },
    showAddReportKpiDialog(){
      this.reportKpiDialogVisible = true;
    },
    closeAddReportKpiDialog(){
      this.reportKpiDialogVisible = false;
    },
    async loadReportKpis(){
      const {data:res} = await this.$http.get(`/report/kpi/selectAll`);
      this.reportKpis = res.data;
    },
    async createReportKpi(){
      this.reportKpi.creator = this.userId;
      const {data:res} = await this.$http.post(`/report/kpi`,this.reportKpi);
      if (res.code === 200){
        this.$message.success("操作成功！");
      }
      this.closeAddReportKpiDialog();
      await this.loadReportKpis();
    },
    async loadOrgReportKpis(){
      const {data:res} = await this.$http.get(`/report/kpi/select/orgId/${this.selectOrgId}`);
      this.orgReportKpi.reportKpiIds = res.data;
    },
    async orgReportSet(){
      this.orgReportKpi.orgIds = this.$refs.tree.getCheckedKeys();
      if (this.orgReportKpi.orgIds.length === 0){
        return this.$message.warning("请选择机构！")
      }
      if (this.orgReportKpi.reportKpiIds.length === 0){
        return this.$message.warning("请选择报表统计项目！")
      }
      const {data:res} = await this.$http.post(`/report/kpi/set/orgId`,this.orgReportKpi);
      await this.loadOrgReportKpis();
      if (res.code === 200){
        this.$message.success("操作成功！");
      }
    },
    // 加载机构树
    async loadOrg(){
      const {data:res} = await this.$http.get(`orgList/orgId/${this.currentOrgId}`);
      this.orgList = [res.data];
    },
  },
  created() {
    this.currentOrgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.loadOrg();
    this.loadReportKpis();
  }

}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  //justify-content: space-between;
  align-items: flex-start;
  height: 90vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}

.left_con{
  display: flex;
  //justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  margin: 10px 0;
  width: 100px;
}
.left_inner_con{
  width: 100%;
  height: 90vh;
  overflow-y: auto;
  margin-right: 10px;
}
.left_inner_con::-webkit-scrollbar {
  width: 0 !important
}
.table_container{
  flex: 1;
  width: 800px;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/ReportSet.vue